module.exports = __webpack_public_path__ + "static/bg-texture-rectangles-357c08ee7e30511c6ff457b3a257fd26.png";